export const CREATE_TASK = 'EPIC/CREATE_TASK';
export const CREATE_TASK_SUCCESS = 'EPIC/CREATE_TASK_SUCCESS';
export const CREATE_TASK_FAILURE = 'EPIC/CREATE_TASK_FAILURE';
